import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@rebass/grid';

import { Text } from '@hey-car/ui';

import { ButtonSt, IconSt, TokenWarningContainerSt } from './TokenWarning.css';

export const TokenWarning = ({ closeOverlay, modalId }) => {
  const onDismissClick = () => {
    if (modalId) {
      closeOverlay();
    }

    return browserHistory.push('/dealer/login');
  };

  return (
    <TokenWarningContainerSt
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <Flex
        as="section"
        bg="white"
        flex={['1', '0 1 356px']}
        flexDirection="column"
        width={['100%', '452px', '424px']}
      >
        <Flex
          as="header"
          flex="0 1 64px"
          flexDirection="row"
          justifyContent="flex-end"
          bg={['brandSecondary', 'white']}
        >
          <IconSt icon="close" onClick={onDismissClick} />
        </Flex>
        <Box as="main" mx={[24, 56]} my={[24, 0]}>
          <Text as="p" fontWeight="bold" lineHeight={2} m={0}>
            <FormattedMessage
              id="dealer.shared.components.TokenWarning.message"
              defaultMessage="Sie wurden aufgrund von Inaktivität automatisch ausgeloggt. Um fortzufahren, loggen Sie sich bitte erneut ein."
            />
          </Text>
        </Box>
        <Flex m={[24, 56]}>
          <ButtonSt onClick={onDismissClick}>
            <FormattedMessage
              id="dealer.shared.components.TokenWarning.button"
              defaultMessage="Erneut einloggen"
            />
          </ButtonSt>
        </Flex>
      </Flex>
    </TokenWarningContainerSt>
  );
};

TokenWarning.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  modalId: PropTypes.string.isRequired,
};
